import {
  Filters,
  SortingMethod,
} from '@common/types';
import _ from 'lodash';

export const queryKeyFrom = (
  filters: Filters,
  currentPage: number,
  sort: SortingMethod,
  isMobileUserAgent: boolean = false,
) => {
  // https://tkdodo.eu/blog/effective-react-query-keys#caching-data
  return _.filter(
    [isMobileUserAgent ? 'templates-mobile' : 'templates', filters, currentPage, sort],
    (el) => !_.isNil(el),
  );
};
